import { Header } from "@/components/lumadeck/Header";
import { Hero } from "@/components/lumadeck/Hero";
import { EditorialMarquee } from "@/components/lumadeck/Marquee";
import { Manifesto } from "@/components/lumadeck/Manifesto";
import { Features } from "@/components/lumadeck/Features";
import { Gallery } from "@/components/lumadeck/Gallery";
import { HowItWorks } from "@/components/lumadeck/HowItWorks";
import { OrderForm } from "@/components/lumadeck/OrderForm";
import { Footer } from "@/components/lumadeck/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Header />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Features />
      <Gallery />
      <HowItWorks />
      <OrderForm />
      <Footer />
    </main>
  );
}
